import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL;

const API_URL = window.APP_CONFIG.API_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

export const generateCaptcha = async () => {
    const response = await api.get('/captcha');
    if (response.status !== 200) {
      throw new Error('Failed to generate captcha');
    }
    return response.data;
  };
  



api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  //输出请求体
  // console.log('Request:', config);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const register = (data) => api.post('/register', data);
export const login = (data) => api.post('/login', data);
export const getUsers = () => api.get('/users');
export const getUser = (id) => api.get(`/users/${id}`);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const redeemCDKey = (data) => api.post('/redeem-cdkey', data);
export const createCDKey = (data) => api.post('/create-cdkey', data);
export const getSelfInfo = () => api.get('/me');
export const getCDKeys = () => api.get('/cdkeys');
export const deleteCDKeys = (selectedCDKeys) => api.delete(`/delete-cdkeys?ids=${selectedCDKeys}`);
export const resetPassword = (data) => api.post('/reset-password', data);
export const forgotPassword = (data) => api.post('/forgot-password', data);
export const resetPasswordWithToken = (token, newPassword) => api.post('/reset-password-with-token', { token, new_password: newPassword });
export const getSMTPConfig = () => api.get('/smtp-config');
export const updateSMTPConfig = (config) => api.post('/smtp-config', config);
export const testSMTPConnection = (data) => api.post('/smtp-test', data);
export const changePassword = (data) => api.post('/change-password', data);

export const getRemoteTexts = () => api.get('/remote-texts');
export const createRemoteText = (data) => api.post('/remote-texts', data);
export const updateRemoteText = (id, data) => api.put(`/remote-texts/${id}`, data);
export const deleteRemoteText = (id) => api.delete(`/remote-texts/${id}`);

export const getFileServerConfig = () => api.get('/file-server-config');
export const updateFileServerConfig = (config) => api.post('/file-server-config', config);
export const getFileServerContent = () => api.get('/file-server-content');

export const getHomepage = () => api.get('/homepage');

export const getAllHomepages = () => api.get('/homepages');
export const createHomepage = (data) => api.post('/homepage', data);
export const updateHomepage = (id, data) => api.put(`/homepage/${id}`, data);
export const deleteHomepage = (id) => api.delete(`/homepages/${id}`);
export const updateHomepageActiveStatus = (id, isActive) => api.put(`/homepages/${id}/active`, { is_active: isActive });

export default api;